import React from 'react';
import { Link } from 'react-router-dom';
import SocialButton from './SocialButton';
import { trackEvent } from '../utils/analytics';
import { ANALYTICS_EVENTS } from '../utils/analyticsEvents';
import { buildAppUrl } from '../utils/appLinks';

export default function Footer() {
  const footerAppLink = buildAppUrl({ medium: 'footer', location: 'footer' });

  return (
    <footer id="contact" className="border-t border-[#D4CFC6] bg-[#F2F0E9]">
      <div className="max-w-6xl mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10">

          {/* Brand column */}
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#CC5833] mb-4">About</p>
            <h3 className="font-display text-2xl text-[#2E4036] mb-4">SistaKyerewaa</h3>
            <p className="text-[#5f5b56] leading-relaxed">
              Integration guidance, health education, and cultural support for African families living in Germany.
            </p>
          </div>

          {/* Navigation column — split into two logical groups */}
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#CC5833] mb-4">Navigate</p>
            <div className="grid grid-cols-2 gap-x-6 gap-y-2 text-[#5f5b56]">
              <Link to="/blog" className="hover:text-[#2E4036] transition-colors">Blog</Link>
              <Link to="/about" className="hover:text-[#2E4036] transition-colors">About</Link>
              <Link to="/store" className="hover:text-[#2E4036] transition-colors">Store</Link>
              <Link to="/partners" className="hover:text-[#2E4036] transition-colors">Partners</Link>
              <Link to="/checklist" className="hover:text-[#2E4036] transition-colors">Checklist</Link>
              <Link to="/book" className="hover:text-[#2E4036] transition-colors">Book a Session</Link>
              <Link to="/faq" className="hover:text-[#2E4036] transition-colors">FAQ</Link>
              <Link to="/privacy" className="hover:text-[#2E4036] transition-colors">Privacy Policy</Link>
            </div>
          </div>

          {/* Connect column */}
          <div>
            <p className="text-xs uppercase tracking-[0.3em] text-[#CC5833] mb-4">Connect</p>
            <div className="flex space-x-4 text-[#5f5b56] mb-6">
              <SocialButton
                url="https://www.facebook.com/Kyerewaasveggiekitchen/"
                label="Facebook"
                hoverClass="hover:text-[#CC5833] min-w-[44px] min-h-[44px] flex items-center justify-center"
              >
                <svg role="img" aria-label="Facebook" xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
                  <title>Facebook</title>
                  <path d="M22.675 0h-21.35C.595 0 0 .592 0 1.326v21.348C0 23.408.595 24 1.325 24h11.495v-9.294H9.692V11.01h3.128V8.413c0-3.1 1.894-4.788 4.659-4.788 1.325 0 2.463.099 2.797.143v3.24l-1.918.001c-1.504 0-1.797.715-1.797 1.763v2.313h3.587l-.467 3.696h-3.12V24h6.116c.73 0 1.324-.592 1.324-1.326V1.326C24 .592 23.405 0 22.675 0"/>
                </svg>
              </SocialButton>
              <SocialButton
                url="https://www.instagram.com/sistakyerewaa/"
                label="Instagram"
                hoverClass="hover:text-[#CC5833] min-w-[44px] min-h-[44px] flex items-center justify-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12 2.163c3.204 0 3.584.012 4.85.07 1.366.062 2.633.332 3.608 1.308.974.976 1.246 2.243 1.308 3.608.058 1.266.069 1.646.069 4.85s-.012 3.584-.07 4.85c-.062 1.366-.332 2.633-1.308 3.608-.976.974-2.243 1.246-3.608 1.308-1.266.058-1.646.069-4.85.069s-3.584-.012-4.85-.07c-1.366-.062-2.633-.332-3.608-1.308-.974-.976-1.246-2.243-1.308-3.608C2.175 15.647 2.163 15.267 2.163 12s.012-3.584.07-4.85c.062-1.366.332-2.633 1.308-3.608C4.515 2.565 5.782 2.293 7.148 2.231 8.414 2.173 8.794 2.163 12 2.163zm0-2.163C8.741 0 8.332.013 7.052.072 5.777.131 4.602.438 3.678 1.362 2.753 2.287 2.446 3.461 2.387 4.737 2.329 6.017 2.316 6.426 2.316 12s.013 5.983.071 7.263c.059 1.276.366 2.45 1.291 3.375.925.924 2.099 1.231 3.375 1.29 1.28.059 1.689.072 7.263.072s5.983-.013 7.263-.071c1.276-.059 2.45-.366 3.375-1.291.924-.925 1.231-2.099 1.29-3.375.059-1.28.072-1.689.072-7.263s-.013-5.983-.071-7.263c-.059-1.276-.366-2.45-1.291-3.375C21.45.366 20.276.059 19 .001 17.72-.058 17.311-.071 12-.071zm0 5.838A6.163 6.163 0 1 0 18.163 12 6.163 6.163 0 0 0 12 5.93zm0 10.163A4 4 0 1 1 16 12a4 4 0 0 1-4 4zm6.406-11.845a1.44 1.44 0 1 0 1.44 1.44 1.44 1.44 0 0 0-1.44-1.44z"/>
                </svg>
              </SocialButton>
              <SocialButton
                url="https://www.tiktok.com/@sistakyerewaa"
                label="TikTok"
                hoverClass="hover:text-[#CC5833] min-w-[44px] min-h-[44px] flex items-center justify-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M12.983 2.001h3.001c.001 1.657 1.343 3 3 3v3.001c-1.104 0-2.001-.896-2.001-2.001h-1.001v7.003c0 3.313-2.686 6-6 6s-6-2.687-6-6c0-2.757 2.243-5 5-5 .552 0 1 .447 1 1s-.448 1-1 1c-1.654 0-3 1.346-3 3 0 1.654 1.346 3 3 3s3-1.346 3-3V2.001z"/>
                </svg>
              </SocialButton>
              <SocialButton
                url="https://www.youtube.com/channel/UC-F1hzylEnv0zqZWU-_HFSg"
                label="YouTube"
                hoverClass="hover:text-[#CC5833] min-w-[44px] min-h-[44px] flex items-center justify-center"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M23.498 6.186a2.997 2.997 0 0 0-2.112-2.112C19.646 3.5 12 3.5 12 3.5s-7.646 0-9.386.574a2.997 2.997 0 0 0-2.112 2.112C0 7.926 0 12 0 12s0 4.074.502 5.814a2.997 2.997 0 0 0 2.112 2.112C4.354 20.5 12 20.5 12 20.5s7.646 0 9.386-.574a2.997 2.997 0 0 0 2.112-2.112C24 16.074 24 12 24 12s0-4.074-.502-5.814zM9.545 15.568V8.432l6.545 3.568-6.545 3.568z"/>
                </svg>
              </SocialButton>
            </div>
            <a
              href={footerAppLink}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent(ANALYTICS_EVENTS.APP_OPEN_CLICK, { location: 'footer', outbound: true })}
              className="inline-flex items-center justify-center px-5 py-2.5 border border-[#8C7B6B]/40 text-xs uppercase tracking-[0.25em] text-[#2E4036] hover:bg-[#e7e4df] transition-colors"
            >
              Start Learning App
            </a>
          </div>
        </div>

        {/* Bottom strip */}
        <div className="mt-10 pt-6 border-t border-[#D4CFC6] flex flex-col sm:flex-row items-center justify-between gap-3 text-xs uppercase tracking-[0.2em] text-[#8C7B6B]">
          <span>&copy; {new Date().getFullYear()} SistaKyerewaa. All rights reserved.</span>
          <button
            type="button"
            onClick={() => {
              if (typeof window !== 'undefined') {
                window.dispatchEvent(new Event('cookie-consent:open'));
              }
            }}
            className="hover:text-[#2E4036] transition-colors"
          >
            Cookie Settings
          </button>
        </div>
      </div>
    </footer>
  );
}
